import axios from "axios";
import { adminMainUrl } from "../../../../Config";


//country state  city ports data
export const getFFSICountry = (token, user_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_SI_COUNTRY_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/country/list`;
        try {
            axios(apiUrl,  config).then((res) => {
                dispatch({
                    type: "FIND_FF_SI_COUNTRY_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFSICountry function (redux):", err);
                dispatch({
                    type: "FIND_FF_SI_COUNTRY_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFSICountry function:", error);
            dispatch({
                type: "FIND_FF_SI_COUNTRY_FAILURE",
                payload: error,
            });
        }
    };
};
export const getFFSIState = (token, user_id, country_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_SI_STATE_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/state/list?country_id=${country_id}`;
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_SI_STATE_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFSIState function (redux):", err);
                dispatch({
                    type: "FIND_FF_SI_STATE_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFSIState function:", error);
            dispatch({
                type: "FIND_FF_SI_STATE_FAILURE",
                payload: error,
            });
        }
    };
};
export const getFFSICity = (token, user_id, state_id) => {

    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_SI_CITY_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        // const body = { quotation_id: quotation_id }

        const apiUrl = `${adminMainUrl}/api/city/list?state_id=${state_id}`;
        try {
            axios(apiUrl,  config).then((res) => {
                dispatch({
                    type: "FIND_FF_SI_CITY_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFSICity function (redux):", err);
                dispatch({
                    type: "FIND_FF_SI_CITY_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFSICity function:", error);
            dispatch({
                type: "FIND_FF_SI_CITY_FAILURE",
                payload: error,
            });
        }
    };
};
export const getFFSISeaport = (token, user_id, quotation_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_SI_SEAPORT_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        // const body = { quotation_id: quotation_id }

        const apiUrl = `${adminMainUrl}/api/seaport/list`;
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_SI_SEAPORT_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFSISeaport function (redux):", err);
                dispatch({
                    type: "FIND_FF_SI_SEAPORT_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFSISeaport function:", error);
            dispatch({
                type: "FIND_FF_SI_SEAPORT_FAILURE",
                payload: error,
            });
        }
    };
};


//ff -> air -> export -> get query info by quotation
export const getPackageInfoByQuotation = (token, user_id, quotation_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_QUERY_INFO_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const body = { quotation_id: quotation_id }

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/get-query-info-by-quotation-id`;
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_FF_QUERY_INFO_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getPackageInfoByQuotation function (redux):", err);
                dispatch({
                    type: "FIND_FF_QUERY_INFO_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getPackageInfoByQuotation function:", error);
            dispatch({
                type: "FIND_FF_QUERY_INFO_FAILURE",
                payload: error,
            });
        }
    };
};


//ff -> air -> export -> job order
export const getFFSeaImpJobOrder = (token, user_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_SEA_IMP_JOBORDER_REQUEST",
        });

        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        const apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/joborderlist`;
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_SEA_IMP_JOBORDER_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFSeaImpJobOrder function (redux):", err);
                dispatch({
                    type: "FIND_FF_SEA_IMP_JOBORDER_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFSeaImpJobOrder function:", error);
            dispatch({
                type: "FIND_FF_SEA_IMP_JOBORDER_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> final Quotation 
export const getFFSeaImpFinalQuotation = (token, user_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_SEA_IMP_FINAL_QUOTATION_REQUEST",
        });

        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/final-quotation-list`;
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_SEA_IMP_FINAL_QUOTATION_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFSeaImpFinalQuotation function (redux):", err);
                dispatch({
                    type: "FIND_FF_SEA_IMP_FINAL_QUOTATION_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFSeaImpFinalQuotation function:", error);
            dispatch({
                type: "FIND_FF_SEA_IMP_FINAL_QUOTATION_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> currency 
export const getFFSeaImpCurrency = (token, user_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_SEA_IMP_CURRENCY_REQUEST",
        });

        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/currency/list`;
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_SEA_IMP_CURRENCY_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFSeaImpCurrency function (redux):", err);
                dispatch({
                    type: "FIND_FF_SEA_IMP_CURRENCY_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFSeaImpCurrency function:", error);
            dispatch({
                type: "FIND_FF_SEA_IMP_CURRENCY_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> Airport 
export const getFFSeaImpAirport = (token, user_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_SEA_IMP_AIRPORT_REQUEST",
        });

        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/airport/list`;
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_SEA_IMP_AIRPORT_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFSeaImpAirport function (redux):", err);
                dispatch({
                    type: "FIND_FF_SEA_IMP_AIRPORT_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFSeaImpAirport function:", error);
            dispatch({
                type: "FIND_FF_SEA_IMP_AIRPORT_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> Organisation 
export const getFFSeaImpOrganisation = (token, user_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_SEA_IMP_ORGANISATION_REQUEST",
        });

        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/organisation-list`;
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_SEA_IMP_ORGANISATION_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFSeaImpOrganisation function (redux):", err);
                dispatch({
                    type: "FIND_FF_SEA_IMP_ORGANISATION_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFSeaImpOrganisation function:", error);
            dispatch({
                type: "FIND_FF_SEA_IMP_ORGANISATION_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> mawb -> unused hawb List 
export const getFFSeaImpUnusedHBLList = (token, user_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_SEA_IMP_UNUSED_HAWB_REQUEST",
        });

        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/sea/import/get-unused-hbl-list`;
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_SEA_IMP_UNUSED_HAWB_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFSeaImpUnusedHBLList function (redux):", err);
                dispatch({
                    type: "FIND_FF_SEA_IMP_UNUSED_HAWB_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFSeaImpUnusedHBLList function:", error);
            dispatch({
                type: "FIND_FF_SEA_IMP_UNUSED_HAWB_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> mawb -> unused hawb List  update
export const getFFSeaImpUnusedHAWBUpdateList = (token, user_id, mawb_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_SEA_IMP_UNUSED_HAWB_UPDATE_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/sea/import/get-unused-hbl-list-update?mbl_id=${mawb_id}`;
        // let body = { id: mawb_id }
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_SEA_IMP_UNUSED_HAWB_UPDATE_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFSeaImpUnusedHAWBUpdateList function (redux):", err);
                dispatch({
                    type: "FIND_FF_SEA_IMP_UNUSED_HAWB_UPDATE_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFSeaImpUnusedHAWBUpdateList function:", error);
            dispatch({
                type: "FIND_FF_SEA_IMP_UNUSED_HAWB_UPDATE_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> hawbb details 
export const getFFSeaImportHBLDetail = (token, user_id, hawb_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_SEA_IMP_HAWB_DETAIL_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/sea/import/hbl/view`;
        let body = { id: hawb_id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_FF_SEA_IMP_HAWB_DETAIL_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFSeaImportHBLDetail function (redux):", err);
                dispatch({
                    type: "FIND_FF_SEA_IMP_HAWB_DETAIL_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFSeaImportHBLDetail function:", error);
            dispatch({
                type: "FIND_FF_SEA_IMP_HAWB_DETAIL_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> direct MAWB details 
export const getFFSeaImporDirectMAWBDetail = (token, user_id, hawb_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_SEA_IMP_DIRECT_MAWB_DETAIL_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/sea/import/direct-shipment/mbl/view`;
        let body = { id: hawb_id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_FF_SEA_IMP_DIRECT_MAWB_DETAIL_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFSeaImporDirectMAWBDetail function (redux):", err);
                dispatch({
                    type: "FIND_FF_SEA_IMP_DIRECT_MAWB_DETAIL_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFSeaImporDirectMAWBDetail function:", error);
            dispatch({
                type: "FIND_FF_SEA_IMP_DIRECT_MAWB_DETAIL_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> mawb details 
export const getFFSeaImportMBLDetail = (token, user_id, mawb_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_SEA_IMP_MAWB_DETAIL_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/sea/import/mbl/view`;
        let body = { id: mawb_id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_FF_SEA_IMP_MAWB_DETAIL_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFSeaImportMAWBDetail function (redux):", err);
                dispatch({
                    type: "FIND_FF_SEA_IMP_MAWB_DETAIL_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFSeaImportMAWBDetail function:", error);
            dispatch({
                type: "FIND_FF_SEA_IMP_MAWB_DETAIL_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> shipper organisation -> branch list 
export const getFFSeaImpShipperBranch = (token, user_id, organisation_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_SEA_IMP_SHIPPER_BRANCH_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const body = { organisation_id: organisation_id }

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/organisation-branch-list`;
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_FF_SEA_IMP_SHIPPER_BRANCH_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFSeaImpShipperBranch function (redux):", err);
                dispatch({
                    type: "FIND_FF_SEA_IMP_SHIPPER_BRANCH_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFSeaImpShipperBranch function:", error);
            dispatch({
                type: "FIND_FF_SEA_IMP_SHIPPER_BRANCH_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> shipper organisation -> branch list 
export const getFFSeaImpConsigneeBranch = (token, user_id, organisation_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_SEA_IMP_CONSIGNEE_BRANCH_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const body = { organisation_id: organisation_id }

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/organisation-branch-list`;
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_FF_SEA_IMP_CONSIGNEE_BRANCH_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFSeaImpConsigneeBranch function (redux):", err);
                dispatch({
                    type: "FIND_FF_SEA_IMP_CONSIGNEE_BRANCH_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFSeaImpConsigneeBranch function:", error);
            dispatch({
                type: "FIND_FF_SEA_IMP_CONSIGNEE_BRANCH_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export ->  shipper -> organisation -> branch list -> Bank account list
export const getFFSeaImpShipperBranchBank = (token, user_id, branch_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_SEA_IMP_SHIPPER_BRANCH_BANK_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        let body = { branch_id: branch_id }

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/branch-bank-list`;
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_FF_SEA_IMP_SHIPPER_BRANCH_BANK_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFSeaImpShipperBranchBank function (redux):", err);
                dispatch({
                    type: "FIND_FF_SEA_IMP_SHIPPER_BRANCH_BANK_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFSeaImpShipperBranchBank function:", error);
            dispatch({
                type: "FIND_FF_SEA_IMP_SHIPPER_BRANCH_BANK_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> consignee -> organisation -> branch list -> Bank account list
export const getFFSeaImpConsigneeBranchBank = (token, user_id, branch_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_SEA_IMP_CONSIGNEE_BRANCH_BANK_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        let body = { branch_id: branch_id }

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/branch-bank-list`;
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_FF_SEA_IMP_CONSIGNEE_BRANCH_BANK_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFSeaImpConsigneeBranchBank function (redux):", err);
                dispatch({
                    type: "FIND_FF_SEA_IMP_CONSIGNEE_BRANCH_BANK_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFSeaImpConsigneeBranchBank function:", error);
            dispatch({
                type: "FIND_FF_SEA_IMP_CONSIGNEE_BRANCH_BANK_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> console shipment List
export const getFFSeaImportConsoleShipmentList = (token, user_id, page_no, ship_status) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_SEA_IMP_CONSOLE_SHIPMENT_LIST_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl;
        if (ship_status == "HBL") {
            apiUrl = `${adminMainUrl}/api/freight/forwarding/sea/import/hbl/list`;
            if (page_no) {
                apiUrl = `${adminMainUrl}/api/freight/forwarding/sea/import/hbl/list?page=${page_no}`;
            }
        } else if (ship_status == "MBL") {
            apiUrl = `${adminMainUrl}/api/freight/forwarding/sea/import/mbl/list`;
            if (page_no) {
                apiUrl = `${adminMainUrl}/api/freight/forwarding/sea/import/mbl/list?page=${page_no}`;
            }
        } else {
            throw new Error("Invalid ship status.")
        }
        // console.log(apiUrl);
        // let apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/hawb/list`;
        // if (page_no) {
        //     apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/hawb/list?page=${page_no}`;
        // }
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_SEA_IMP_CONSOLE_SHIPMENT_LIST_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFSeaImportConsoleShipmentList function (redux):", err);
                dispatch({
                    type: "FIND_FF_SEA_IMP_CONSOLE_SHIPMENT_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFSeaImportConsoleShipmentList function:", error);
            dispatch({
                type: "FIND_FF_SEA_IMP_CONSOLE_SHIPMENT_LIST_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> direct shipment List
export const getFFSeaImportDirectShipmentList = (token, user_id, page_no) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_SEA_IMP_DIRECT_SHIPMENT_LIST_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/freight/forwarding/sea/import/direct-shipment/mbl/list`;
        if (page_no) {
            apiUrl = `${adminMainUrl}/api/freight/forwarding/sea/import/direct-shipment/mbl/list?page=${page_no}`;
        }
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_SEA_IMP_DIRECT_SHIPMENT_LIST_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFSeaImportDirectShipmentList function (redux):", err);
                dispatch({
                    type: "FIND_FF_SEA_IMP_DIRECT_SHIPMENT_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFSeaImportDirectShipmentList function:", error);
            dispatch({
                type: "FIND_FF_SEA_IMP_DIRECT_SHIPMENT_LIST_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> console manifest List
export const getFFSeaImportConsoleManifestList = (token, user_id, page_no) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_SEA_IMP_CONSOLE_MANIFEST_LIST_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/freight/forwarding/sea/import/console-manifest/list`;
        if (page_no) {
            apiUrl = `${adminMainUrl}/api/freight/forwarding/sea/import/console-manifest/list?page=${page_no}`;
        }
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_SEA_IMP_CONSOLE_MANIFEST_LIST_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFSeaImportConsoleManifestList function (redux):", err);
                dispatch({
                    type: "FIND_FF_SEA_IMP_CONSOLE_MANIFEST_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFSeaImportConsoleManifestList function:", error);
            dispatch({
                type: "FIND_FF_SEA_IMP_CONSOLE_MANIFEST_LIST_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> unused mawb in console manifest add form
export const getFFSeaImportConsoleManifestMBLAddList = (token, user_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_SEA_IMP_CONSOLE_MANIFEST_MAWB_ADD_LIST_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/freight/forwarding/sea/import/console-manifest/unused-mbl-add-list`;
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_SEA_IMP_CONSOLE_MANIFEST_MAWB_ADD_LIST_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFSeaImportConsoleManifestMBLAddList function (redux):", err);
                dispatch({
                    type: "FIND_FF_SEA_IMP_CONSOLE_MANIFEST_MAWB_ADD_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFSeaImportConsoleManifestMBLAddList function:", error);
            dispatch({
                type: "FIND_FF_SEA_IMP_CONSOLE_MANIFEST_MAWB_ADD_LIST_FAILURE",
                payload: error,
            });
        }
    };
};

// //ff -> air -> export -> unused mawb in console manifest edit form
// export const getFFSeaImportConsoleManifestMAWBEditList = (token, user_id, console_manifest_id) => {
//     return async function (dispatch) {
//         dispatch({
//             type: "FIND_FF_SEA_IMP_CONSOLE_MANIFEST_MAWB_EDIT_LIST_REQUEST",
//         });

//         let config = {
//             // method: "GET",
//             headers: {
//                 'auth-token': token,
//                 'user_id': user_id,
//                 'Content-Type': 'application/json',
//             }
//         };
//         let apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/console-manifest/unused-mawb-add-list`;
//         let body = { id: console_manifest_id }
//         try {
//             axios.post(apiUrl, body, config).then((res) => {
//                 dispatch({
//                     type: "FIND_FF_SEA_IMP_CONSOLE_MANIFEST_MAWB_EDIT_LIST_SUCCESS",
//                     payload: res?.data?.data,
//                 });
//             }).catch((err) => {
//                 console.log("ERROR in getFFSeaImportConsoleManifestMAWBEditList function (redux):", err);
//                 dispatch({
//                     type: "FIND_FF_SEA_IMP_CONSOLE_MANIFEST_MAWB_EDIT_LIST_FAILURE",
//                     payload: err,
//                 });
//             });
//         } catch (error) {
//             console.log("Unexpected error in getFFSeaImportConsoleManifestMAWBEditList function:", error);
//             dispatch({
//                 type: "FIND_FF_SEA_IMP_CONSOLE_MANIFEST_MAWB_EDIT_LIST_FAILURE",
//                 payload: error,
//             });
//         }
//     };
// };


//calcualte toatl freight in mawb
//ff -> air -> export -> unused mawb in console manifest add form
export const calculateTotalFreightMAWB = (token, user_id, hawb_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_CALCULATE_TOTAL_FREIGHT_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/mawb/calculate-hawb-no`;
        let body = { hawb_id_arr: hawb_id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_CALCULATE_TOTAL_FREIGHT_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in calculateTotalFreightMAWB function (redux):", err);
                dispatch({
                    type: "FIND_CALCULATE_TOTAL_FREIGHT_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in calculateTotalFreightMAWB function:", error);
            dispatch({
                type: "FIND_CALCULATE_TOTAL_FREIGHT_FAILURE",
                payload: error,
            });
        }
    };
};